import React from 'react';

const defaultColor = '#686260'; // primary color

export const Computer = props => {
  const { color = defaultColor, height = '24px' } = props;
  return (
    <svg
      focusable="false"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      height={height}
      fill={color}
    >
      <path d="M20.24 8.56v5.03H3.76V5.65c0-.93.76-1.7 1.7-1.7h8.34c.31-.42.68-.79 1.09-1.1H5.45c-1.54 0-2.79 1.25-2.79 2.79V15.9c0 1.54 1.25 2.79 2.79 2.79h4.57v1.72H8.68c-.3 0-.55.25-.55.55s.25.55.55.55h7.16c.3 0 .55-.25.55-.55s-.25-.55-.55-.55h-1.29V18.7h4c1.54 0 2.79-1.25 2.79-2.79V7.33l-1.1 1.23zm-6.79 11.86h-2.32V18.7h2.32v1.72zm6.79-4.52c0 .93-.76 1.7-1.7 1.7H5.45c-.93 0-1.7-.76-1.7-1.7v-1.21h16.49v1.21z" />
      <path d="M15.05 8.28l.17.39.11.28.06-.28.06-.39c.22-1.06 1.23-1.9 2.34-2.01v.95c0 .06 0 .22.17.28.06.06.17.11.28.11.17 0 .22-.06.28-.11l1.95-2.17c.11-.11.17-.17.17-.33 0-.11-.06-.17-.17-.22l-2.01-2.17a.55.55 0 0 0-.28-.11c-.06 0-.22.06-.28.11a.55.55 0 0 0-.11.28v.95c-1.68.09-3.02 1.48-3.02 3.16 0 .39.12.78.28 1.28zm2.79-3.66l.75-.05v-.66l1.05 1.14-1.05 1.17v-.83l-.88.09c-.78.08-1.5.42-2.06.94.25-.98 1.12-1.73 2.19-1.8z" />
    </svg>
  );
};

export const MagnifyingGlass = props => {
  const { color = defaultColor, height = '24px' } = props;
  return (
    <svg
      focusable="false"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      height={height}
      fill={color}
    >
      <path d="M23.53 21.76l-5.44-5.44c2.25-2.72 2.84-6.5 1.66-9.81C18.32 2.6 14.42 0 10.29 0 4.61 0 0 4.5 0 10.05S4.61 20.1 10.17 20.1c2.13 0 4.26-.71 5.91-1.89l5.56 5.44c.24.24.59.35.95.35s.71-.12.95-.35c.46-.59.46-1.42-.01-1.89zm-13.36-4.38c-4.14 0-7.45-3.31-7.45-7.45s3.31-7.45 7.45-7.45 7.45 3.31 7.45 7.45-3.32 7.45-7.45 7.45z" />
    </svg>
  );
};

export const Lock = () => {
  return (
    <svg
      width="24"
      height="24"
      xmlns="http://www.w3.org/2000/svg"
      fillRule="evenodd"
      clipRule="evenodd"
    >
      <path d="M6 6c0-3.311 2.689-6 6-6s6 2.688 6 6v4h3v14h-18v-14h3v-4zm14 5h-16v12h16v-12zm-13-5v4h10v-4c0-2.76-2.24-5-5-5s-5 2.24-5 5z" />
    </svg>
  );
};

export const Mail = props => {
  const { color = defaultColor, height = '24px' } = props;
  return (
    <svg
      focusable="false"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      height={height}
      fill={color}
    >
      <path d="M18.24 6.77h-2.5c-.69 0-1.25.59-1.25 1.31v2.62c0 .72.56 1.31 1.25 1.31h2.5c.69 0 1.25-.59 1.25-1.31V8.08c0-.73-.56-1.31-1.25-1.31zm.15 3.92c0 .12-.08.21-.15.21h-2.5c-.07 0-.15-.09-.15-.21V8.08c0-.12.08-.21.15-.21h2.5c.07 0 .15.09.15.21v2.61z" />
      <path d="M19.74 4.15H4.26c-1.24 0-2.25 1.01-2.25 2.25v11.2c0 1.24 1.01 2.25 2.25 2.25h15.48c1.24 0 2.25-1.01 2.25-2.25V6.4c0-1.24-1.01-2.25-2.25-2.25zm1.25 13.45c0 .69-.56 1.25-1.25 1.25H4.26c-.69 0-1.25-.56-1.25-1.25V6.4c0-.69.56-1.25 1.25-1.25h15.48c.69 0 1.25.56 1.25 1.25v11.2z" />
      <path d="M12.5 13.41H5.23c-.3 0-.55.25-.55.55s.25.55.55.55h7.27c.3 0 .55-.25.55-.55s-.25-.55-.55-.55zM12.5 16.03H5.23c-.3 0-.55.25-.55.55s.25.55.55.55h7.27c.3 0 .55-.25.55-.55s-.25-.55-.55-.55z" />
    </svg>
  );
};

export const Marker = props => {
  const { color = defaultColor, height = '24px' } = props;
  return (
    <svg
      focusable="false"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      height={height}
      fill={color}
    >
      <path d="M12 6.81c-1.6 0-2.9 1.3-2.9 2.9s1.3 2.9 2.9 2.9 2.9-1.3 2.9-2.9-1.3-2.9-2.9-2.9zm0 4.79a1.9 1.9 0 1 1 0-3.8 1.9 1.9 0 1 1 0 3.8z" />
      <path d="M12 2.7c-3.87 0-7 3.13-7 7s6.18 11.59 7 11.59c.83 0 7-7.72 7-11.59 0-3.86-3.13-7-7-7zm0 17.41c-1.56-1.43-6-7.5-6-10.4 0-3.31 2.69-6 6-6s6 2.69 6 6c0 2.9-4.44 8.97-6 10.4z" />
    </svg>
  );
};

export const Target = props => {
  const { color = defaultColor, height = '24px' } = props;
  return (
    <svg
      focusable="false"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      height={height}
      fill={color}
    >
      <path d="M22.01 11.43h-.48a9.585 9.585 0 0 0-8.95-8.95v-.49c0-.31-.26-.57-.57-.57s-.57.26-.57.57v.48a9.585 9.585 0 0 0-8.95 8.95h-.5c-.31 0-.57.26-.57.57 0 .31.26.57.57.57h.48c.26 4.81 4.14 8.64 8.95 8.95v.48c0 .31.26.57.57.57.31 0 .57-.26.57-.57v-.48c4.81-.26 8.64-4.14 8.95-8.95h.48c.31 0 .57-.26.57-.57.02-.3-.24-.56-.55-.56zm-2.07 1.14h.44c-.26 4.19-3.62 7.54-7.8 7.8v-.44c0-.31-.26-.57-.57-.57-.31 0-.57.26-.57.57v.44c-4.19-.26-7.54-3.62-7.8-7.8h.44c.31 0 .57-.26.57-.57 0-.31-.26-.57-.57-.57h-.46c.26-4.19 3.62-7.54 7.8-7.8v.44c0 .31.26.57.57.57.31 0 .57-.26.57-.57v-.45c4.19.26 7.54 3.62 7.8 7.8h-.44c-.31 0-.57.26-.57.57s.28.58.59.58zm-3.8-1.14h-1.59a2.604 2.604 0 0 0-1.98-1.98V7.86c0-.31-.26-.57-.57-.57-.31 0-.57.26-.57.57v1.59a2.604 2.604 0 0 0-1.98 1.98H7.86c-.31 0-.57.26-.57.57s.26.57.57.57h1.59a2.604 2.604 0 0 0 1.98 1.98v1.59c0 .31.26.57.57.57.31 0 .57-.26.57-.57v-1.59a2.604 2.604 0 0 0 1.98-1.98h1.59c.31 0 .57-.26.57-.57s-.26-.57-.57-.57zM12 13.5c-.84 0-1.5-.66-1.5-1.5s.66-1.5 1.5-1.5 1.5.66 1.5 1.5-.66 1.5-1.5 1.5z" />
    </svg>
  );
};

export const Building = props => {
  const { color = defaultColor, height = '24px', width = '24px' } = props;
  return (
    <svg
      focusable="false"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      height={height}
      width={width}
      fill={color}
    >
      <path d="M18.56 11.53h-1.72c-.99 0-1.8.81-1.8 1.8v5.95h5.32v-5.95c0-.99-.8-1.8-1.8-1.8zm.8 6.75h-3.32v-2.24h3.32v2.24zm0-3.25h-3.32v-1.7c0-.44.36-.8.8-.8h1.72c.44 0 .8.36.8.8v1.7z" />
      <path d="M16.76 13.28h1.88v1.36h-1.88z" />
      <path d="M11.33 13.63c0-.55-.45-1-1-1H7.9c-.55 0-1 .45-1 1v4.64H5.89c-.69 0-1.25-.56-1.25-1.25v-7.3h12.57v.82h1V6.97c0-1.24-1.01-2.25-2.25-2.25H5.89c-1.24 0-2.25 1.01-2.25 2.25v10.06c0 1.24 1.01 2.25 2.25 2.25H14.04v-1h-2.71v-4.65zM4.64 6.97c0-.69.56-1.25 1.25-1.25h10.07c.69 0 1.25.56 1.25 1.25v1.74H4.64V6.97zm5.69 11.31H7.9v-4.64h2.43v4.64z" />
    </svg>
  );
};

export const HelpPlay = props => {
  const { color = defaultColor, height = '24px', width = '24px' } = props;
  return (
    <svg
      focusable="false"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      height={height}
      width={width}
      fill={color}
    >
      <path
        d="M12,24 C5.372583,24 0,18.627417 0,12 C0,5.372583 5.372583,0 12,0 C18.627417,0 24,5.372583 24,12 C24,18.627417 18.627417,24 12,24 Z M18,12 L9,7 L9,17 L18,12 Z"
        id="Combined-Shape"
        fill="#DB1929"
      />
    </svg>
  );
};

export const Cog = props => {
  const { color = defaultColor, height = '24px', width = '24px' } = props;
  return (
    <svg
      focusable="false"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 32 32"
      height={height}
      width={width}
      className="cog-icon"
      stroke={color}
    >
      <g id="Page-1" strokeWidth="2" fill="none" fillRule="evenodd">
        <g id="Cog" strokeWidth="2">
          <path
            d="M10.3104914,6.35069345 C11.2017643,5.82403894 12.1723412,5.41735005 13.2,5.15284896 L13.2,4 L13.2,4 C13.2,2.8954305 14.0954305,2 15.2,2 L16.8,2 C17.9045695,2 18.8,2.8954305 18.8,4 L18.8,5.15284896 C19.8276588,5.41735005 20.7982357,5.82403894 21.6895086,6.35069345 L22.5053824,5.53481964 C23.286431,4.75377105 24.5527609,4.75377105 25.3338095,5.53481964 L25.3338095,5.53481964 L26.4651804,6.66619049 L26.4651804,6.66619049 C27.2462289,7.44723907 27.2462289,8.71356903 26.4651804,9.49461761 L25.6493065,10.3104914 C26.1759611,11.2017643 26.58265,12.1723412 26.847151,13.2 L28,13.2 C29.1045695,13.2 30,14.0954305 30,15.2 L30,16.8 C30,17.9045695 29.1045695,18.8 28,18.8 L26.847151,18.8 C26.58265,19.8276588 26.1759611,20.7982357 25.6493065,21.6895086 L26.4651804,22.5053824 C27.2462289,23.286431 27.2462289,24.5527609 26.4651804,25.3338095 L25.3338095,26.4651804 C24.5527609,27.2462289 23.286431,27.2462289 22.5053824,26.4651804 L21.6895086,25.6493065 C20.7982357,26.1759611 19.8276588,26.58265 18.8,26.847151 L18.8,28 C18.8,29.1045695 17.9045695,30 16.8,30 L15.2,30 C14.0954305,30 13.2,29.1045695 13.2,28 L13.2,26.847151 C12.1723412,26.58265 11.2017643,26.1759611 10.3104914,25.6493065 L9.49461761,26.4651804 L9.49461761,26.4651804 C8.71356903,27.2462289 7.44723907,27.2462289 6.66619049,26.4651804 L5.53481964,25.3338095 L5.53481964,25.3338095 C4.75377105,24.5527609 4.75377105,23.286431 5.53481964,22.5053824 L6.35069345,21.6895086 C5.82403894,20.7982357 5.41735005,19.8276588 5.15284896,18.8 L4,18.8 C2.8954305,18.8 2,17.9045695 2,16.8 L2,15.2 C2,14.0954305 2.8954305,13.2 4,13.2 L5.15284896,13.2 C5.41735005,12.1723412 5.82403894,11.2017643 6.35069345,10.3104914 L5.53481964,9.49461761 C4.75377105,8.71356903 4.75377105,7.44723907 5.53481964,6.66619049 L6.66619049,5.53481964 C7.44723907,4.75377105 8.71356903,4.75377105 9.49461761,5.53481964 L10.3104914,6.35069345 Z"
            id="Combined-Shape"
          />
          <circle id="Oval-2" cx="16" cy="16" r="5" />
        </g>
      </g>
    </svg>
  );
};



// WEBPACK FOOTER //
// ./src/components/Icons.js